import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import contactsImport from './contactsImport'
import linkedin from './linkedin'
import zhenyunStore from "./zhenyunStore.js"
import permissionVerification from './permissionVerification.js'
import serviceAgreement from './serviceAgreement.js'
import createPersistedState from 'vuex-persistedstate'
import orderInfo from './orderInfo'
import { getUserInfo } from '@/utils/api';
import { salesInfo } from '@/utils/api/dashboard';
import { loginUrl, onlineUrl } from '@/utils/config';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuCollapse: !!+Cookies.get('isCollapse') || false, //左侧菜单的切换状态（暂不加）
    language: localStorage.getItem('lang') || 'cn',
    userInfo: {},
    isPermission: false,
    supplierState:{},
    getSalesInfoLoading: false, //获取sales-info接口的状态
    salesInfoData: {},
    subscribeKit: false,
    historySubscribeKit: false,
    bubbles:{ //订单售后气泡
      supplier_deduction_num:0,  
      supplier_refund_num :0
    },
    brandBusinessModel:[]
  },
  mutations: {
    SET_BRAND_BUSINESS_MODEL(state,payload){
      state.brandBusinessModel = payload || []
    },
    SET_USERINFO(state, payload) {
      state.userInfo = payload || {};
    },
    SET_PERMISSION(state, payload) {
      state.isPermission = payload;
    },

    SET_SUBSCRIBEKIT(state, payload){
      state.subscribeKit = payload
    },
    SET_HISTORYSUBSCRIBEKIT(state, payload){
      state.historySubscribeKit = payload
    },
    
    CHANGE_MENU_OPEN(state) {
      state.menuCollapse = !state.menuCollapse;
      if(state.menuCollapse) {
        Cookies.set('isCollapse', 1);
      }else {
        Cookies.set('isCollapse', 0);
      }
    },
    CHANGE_LANG(state, payload) {
      state.language = payload;
    },
    SET_SUPPLIERSTATE(state, payload) {
      state.supplierState = payload || {};
    },
    SET_DEDUCTION_NUM(state, payload){
      state.bubbles.supplier_deduction_num = payload
    },
    SET_REFUND_NUM(state, payload){
      state.bubbles.supplier_refund_num = payload
    },
  },
  actions: {
    // 当没权限时，路由跳转前会再请求并校验一次身份，符合放行，不符合直接403
    checkUserInfo({commit, state}, checkUpgradeFn) {
      return new Promise((resolve, reject)=> {
        getUserInfo()
          .then(res=> {
            if(res.rspResult.bizCode == 200) {
              if(res.data.compId) {
                if(res.data.compType === 1) {
                  // if(!res.data.expireLongTime) {
                    commit('SET_USERINFO', res.data);
                    commit('SET_PERMISSION', true);
                    checkUpgradeFn && checkUpgradeFn();
                    resolve(true);
                  // }else {
                  //   window.location.replace(`${ onlineUrl }/supplier-service/expire`);
                  // }
                }else {
                  resolve(false);
                }
              }else {
                const href = `${loginUrl}/pst/login?returnURL=${window.location.href}` 
                window.location.href = href;
              }
            }else {
              resolve(false);
            }
          })
          .catch(err=> {
            if(err === 'haizol-request-cancel') {
              resolve(true);  
            }
            reject('getUserInfo Error!');
          })
      })
    },
    getSalesInfo({commit, state}) {
      if(state.getSalesInfoLoading) return;
      state.getSalesInfoLoading = true;
      const params = {
        t: Date.now()
      }
      salesInfo(params)
        .then(res=> {
          state.getSalesInfoLoading = false;
          if(res.rspResult.bizCode == 200) {
            state.salesInfoData = res.data || {};
            state.renewInfoData = res.rc;
          }
        })
        .catch(err=> {
          state.getSalesInfoLoading = false;
          console.error('查询客户经理信息失败', err)
        })
    },
  },
  getters: {
    menuCollapseGetter(state) {
      return state.menuCollapse;
    },
    signGetter(state) {
      return state.userInfo.sign || false
    },
    lang(state) {
      return state.language;
    },
    supplierState(state){
      return state.supplierState;
    },
    salesInfoGetter(state) {
      return state.salesInfoData;
    }
  },
  modules: {
    contactsImport,
    linkedin,
    permissionVerification,
    orderInfo,
    serviceAgreement,
    zhenyunStore
  },
  plugins: [
    createPersistedState({
      key: 'sass-console-vuex',
      paths: [
        'menuCollapse', 
        'language', 
        'userInfo', 
        // 'isPermission', 
        'supplierState', 
        'orderInfo', 
        'serviceAgreement'
      ],
      storage: window.sessionStorage,
    })
  ]
})
